export const initialTyreState = {
  tyres: [],
  loading: false,
  page: 1,
  hasMore: true,
  openTyreId: null,
  addToCartLoadingId: '',
  _apiId: null,
};

export const createTyreSlice = (set, get) => ({
  ...initialTyreState,

  setOpenTyreId: (id) => {
    const { openTyreId } = get();
    set({ openTyreId: openTyreId === id ? null : id });
  },

  updateTyre: (id, updates) => {
    set((state) => ({
      tyres: state.tyres.map((t) => (t._id === id ? { ...t, ...updates } : t)),
    }));
  },

  setAddToCartLoadingId: (id) => set({ addToCartLoadingId: id }),
});
